<template>
  <Sortable
    :list="array"
    :options="{animation: 150, handle: '.handle', forceFallback: true}"
    @update="handleChange"
    tag="div"
    item-key="id"
  >
    <template #item="{ element: object, index: idx }">
      <div class="item">
        <slot name="item" :object="object" :index="idx"></slot>
      </div>
    </template>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </Sortable>
</template>

<script setup lang="ts">
import copy from '@virgodev/bazaar/functions/copy';
import { Sortable } from "sortablejs-vue3";
import { computed } from "vue";

const props = defineProps<{ list: object[] }>();
const emit = defineEmits(['update:list']);
const array = computed({
  get() {
    return props.list;
  },
  set(val) {
    emit('update:list', val);
  },
});

async function handleChange(e) {
  const array2 = copy(array.value);
  const item = array2.splice(e.oldIndex, 1)[0];
  array2.splice(e.newIndex, 0, item);
  emit('update:list', array2.filter((a) => a));
}
</script>
